var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21118 7.02486C5.45302 6.7921 5.83596 6.79335 6.07628 7.02768L9.9691 10.8234C10.2149 11.0631 10.6085 11.0582 10.8482 10.8123L11.0907 10.5636C11.3304 10.3178 11.3254 9.92422 11.0796 9.68453L7.25127 5.95166C6.9999 5.70656 7.00122 5.30208 7.25418 5.05863L11.1066 1.35103C11.3539 1.11294 11.3615 0.719388 11.1234 0.472005L10.8825 0.221738C10.6444 -0.0256449 10.2509 -0.0331813 10.0035 0.204905L6.08623 3.97497C5.84439 4.20773 5.46145 4.20648 5.22113 3.97215L1.32848 0.17657C1.08266 -0.0631248 0.689065 -0.0581555 0.44937 0.18767L0.206881 0.43636C-0.0328136 0.682185 -0.0278442 1.07578 0.217981 1.31547L4.04614 5.04817C4.29751 5.29327 4.29619 5.69775 4.04323 5.9412L0.190583 9.64906C-0.0568007 9.88715 -0.0643374 10.2807 0.173749 10.5281L0.41461 10.7783C0.652697 11.0257 1.04625 11.0333 1.29363 10.7952L5.21118 7.02486Z",
    fill: "#F25151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.ec06840217e3a38ea9b64c5f9220a063.svg";
export { ForwardRef as ReactComponent };